// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectBMCounterMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.BM_COUNTER_MESSAGE);
        this.UnreadIDs = null;
    }
}
